import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { useActiveSessionWatcher } from "@/hooks/useActiveSessionWatcher";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  // Watch for session completions globally (shows toast + browser notification)
  useActiveSessionWatcher();

  if (loading)
    return (
      <div className="flex items-center justify-center h-screen bg-background text-foreground">
        Loading...
      </div>
    );

  if (!user) return <Navigate to="/" replace />;

  return <>{children}</>;
}
